/**
 * Normalizes dashboard / notification activity items from API or local shapes.
 * @param {unknown} it
 */
export function normalizeActivityItem(it) {
  if (!it || typeof it !== "object") return null;
  const o = it;
  return {
    kind: o.kind === "contact" ? "contact" : "request",
    id: String(o.id),
    typeLabel: o.typeLabel || o.type_label || "—",
    title: o.title || "—",
    subtitle: o.subtitle || o.email || o.preview || "",
    status: o.status || "new",
    unread: Boolean(o.unread),
    replyCount: o.replyCount ?? o.reply_count ?? 0,
    createdAt: o.createdAt || o.created_at || new Date().toISOString(),
    requesterType: o.requesterType || o.requester_type || null,
  };
}

/**
 * @param {unknown} arr
 * @returns {ReturnType<typeof normalizeActivityItem>[]}
 */
export function normalizeActivityList(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map(normalizeActivityItem).filter(Boolean);
}
